import { PathMenuItem } from 'core/FeaturePathMenus';

export const pathMenus: PathMenuItem[] = [
    {
        url_id: '/laporan/status-rekening-kuasa',
        url_path: '/laporan/status-rekening-kuasa',
    },
];
